import clsx from "clsx";
import { useId } from "react";
import { MdInfo, MdOutlineSaveAs } from "react-icons/md";
import { Tooltip } from "react-tooltip";
import { ICON_SIZES } from "src/helpers/constants";
import useMobile from "src/hooks/useMobile";
import SlideDownUpAnimation from "../Animations/SlideDownUpAnimation";

interface IChangesPendingToSave {
  show: boolean;
}

const ChangesPendingToSave: React.FC<IChangesPendingToSave> = ({ show }) => {
  const tooltipId = useId();
  const { isMobile } = useMobile();

  return (
    <div className="flex-shrink-0">
      <SlideDownUpAnimation show={show}>
        <div
          className={clsx([
            "flex",
            "flex-row",
            "items-center",
            "gap-1",
            "flex-shrink-0",
          ])}
          data-tooltip-id={tooltipId}
          data-tooltip-content="Tienes cambios sin guardar"
          data-tooltip-position-strategy="fixed"
          data-tooltip-offset={0}
        >
          <MdInfo
            size={isMobile ? ICON_SIZES.SM : ICON_SIZES.SM}
            className={clsx([
              "text-red-500",
              "dark:text-purple-400",
              "shrink-0",
            ])}
          />
          <span className={clsx(["!text-xs", "font-medium", "shrink-0"])}>
            Editado
          </span>
          <Tooltip
            id={tooltipId}
            style={{ zIndex: 99 }}
            positionStrategy="fixed"
          />
        </div>
      </SlideDownUpAnimation>
    </div>
  );
};

export default ChangesPendingToSave;
